export const PhysiotherapyAssessmentConsultationKey = "PhysiotherapyAssessmentConsultationKey";

export enum PhysiotherapyAssessmentConsultationTemplate {
    Face2Face = "Face2Face",
    Telephone = "Telephone",
    Video = "Video",
    Review = "Review"
}

export const physiotherapyAssessmentConsultationTemplateOptions = [
    { text: "Face to Face", value: PhysiotherapyAssessmentConsultationTemplate.Face2Face },
    { text: "Telephone", value: PhysiotherapyAssessmentConsultationTemplate.Telephone },
    { text: "Video", value: PhysiotherapyAssessmentConsultationTemplate.Video },
    { text: "Review", value: PhysiotherapyAssessmentConsultationTemplate.Review }
];

export enum AdherenceToHomeExerciseAndAdvicePlan {
    Yes = "Yes",
    No = "No",
    NotApplicable = "NotApplicable"
}

export const adherenceToHomeExerciseAndAdvicePlanOptions = [
    { text: "Yes", value: AdherenceToHomeExerciseAndAdvicePlan.Yes },
    { text: "No", value: AdherenceToHomeExerciseAndAdvicePlan.No },
    { text: "NotApplicable", value: AdherenceToHomeExerciseAndAdvicePlan.NotApplicable }
];

export const injuredQuestionOptions = [
    { label: "At work", value: "At work" },
    { label: "Outside work", value: "Outside work" },
    { label: "Combination", value: "Combination" },
    { label: "Degeneration", value: "Degeneration" }
];

export enum SmokingStatus {
    Yes = "Yes",
    No = "No",
    ExSmoker = "ExSmoker"
}

export const smokingStatusQuestionOptions = [
    { text: "Yes", value: SmokingStatus.Yes },
    { text: "No", value: SmokingStatus.No },
    { text: "Ex smoker", value: SmokingStatus.ExSmoker }
];

export enum Outcome {
    Discharged = "Discharged",
    Review = "Review",
    ReferToGpOrSpecialistAndNoReview = "ReferToGpOrSpecialistAndNoReview",
    ReferToGpOrSpecialistAndReview = "ReferToGpOrSpecialistAndReview"
}

export const outcomeQuestionOptions = [
    { text: "Discharged", value: Outcome.Discharged },
    { text: "Review", value: Outcome.Review },
    { text: "Refer to GP or Specialist and No Review", value: Outcome.ReferToGpOrSpecialistAndNoReview },
    { text: "Refer to GP or Specialist and Review", value: Outcome.ReferToGpOrSpecialistAndReview },
];

export enum CurrentWorkStatus {
    AtWork = "AtWork",
    NotAtWork = "NotAtWork"
}

export const currentWorkStatusOptions = [
    { text: "At Work", value: CurrentWorkStatus.AtWork },
    { text: "Not At Work", value: CurrentWorkStatus.NotAtWork }
];

export enum ConsentToReleaseTheReportAnswers {
    CopyRequired = "CopyRequired",
    CopyRequiredSameTime = "CopyRequiredSameTime",
    AlternativeScope = "AlternativeScope"
}

export enum PhysiotherapyReferralOrigin {
    MGR = "MGR",
    SELF = "SELF"
}

export const PhysiotherapyReferralOriginOptions: { text: string; value: string }[] = [
    { text: "Manager referral", value: PhysiotherapyReferralOrigin.MGR },
    { text: "Self referral", value: PhysiotherapyReferralOrigin.SELF }
];
